const swiperMain = document.querySelector(".swiper_main");
const autoSlide = swiperMain.dataset.autoSlide;
const slideTime = swiperMain.dataset.slideTime;
const slideSecond = slideTime * 1000;
//console.log("autoSlide", autoSlide);
//console.log("slideSecond", slideSecond);

//サムネイル
const swiperThumbnail = new Swiper(".swiper_thumbnail", {
  slidesPerView: 4,
  spaceBetween: 8,
  breakpoints: {
    749: {
      slidesPerView: 6,
      spaceBetween: 16,
    },
  },
});

const swiper = new Swiper(".swiper_main", {
  loop: true,
  autoplay: {
    delay: slideSecond,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiperThumbnail,
  },
});

swiper.autoplay.stop();

if (autoSlide === "true") {
  swiper.autoplay.start();
}
